export const aciStops = {
    iconName: 'stops',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 11' },
        circle: {
            attr: {
                cx: '13.5',
                cy: '5.5',
                r: '4.75',
                stroke: 'currentColor',
                'stroke-width': '1.5',
            },
        },
        path: {
            attr: {
                d: 'M1 6h7-7zM19 6h4-4z',
                stroke: 'currentColor',
                'stroke-width': '1.5',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
